import { render, staticRenderFns } from "./_collectionHandle.vue?vue&type=template&id=8fda20ce&scoped=true&"
import script from "./_collectionHandle.vue?vue&type=script&lang=js&"
export * from "./_collectionHandle.vue?vue&type=script&lang=js&"
import style0 from "./_collectionHandle.vue?vue&type=style&index=0&id=8fda20ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fda20ce",
  null
  
)

export default component.exports